import { BitrixVue } from 'ui.vue';

BitrixVue.cloneComponent('AdditionalRow3', 'Steps', {
	data() {
		return {
			visabilityInner: false,
			selectedOverlay: null,
			selectedOverlayColor: null,
			additional: null,
			liningDimensionsWidth: null,
			liningDimensionsHeight: null,
			obkatkaDimensionsWidth: null,
			obkatkaDimensionsHeight: null,
		};
	},
	created() {
		this.getDataStep();
	},
	methods: {
		isAdditionalReady() {
			return this.additional;
		},
		deactivate() {
			this.visabilityInner = !this.visabilityInner;
			this.selectedOverlay = null;
			this.selectedOverlayColor = null;
		},
		setActiveElement(index) {
			if (this.selectedOverlay !== index) {
				this.selectedOverlayColor = null;
			}
			this.selectedOverlay = index;
		},
		getDataStep: function () {
			let context = this;
			let req = BX.ajax.runComponentAction(
				'mworks:configurator',
				'getDataAdditional3',
				{
					mode: 'class',
					method: 'post',
					data: {
						position: '',
					},
				}
			);

			req.catch(function (response) {
			});

			req.then((response) => {
				if (response.status == 'success') {
					context.additional = response.data.result;
				}
			});
		},
	},
	watch: {
		visabilityInner(val) {
			if (val) {
				this.additional.liningDimensionsWidth.forEach((item) => {
					if (item.value === this.liningDimensionsWidth)
						this.setPropPosition({ liningDimensionsWidth: item });
				});
				this.additional.liningDimensionsHeight.forEach((item) => {
					if (item.value === this.liningDimensionsHeight)
						this.setPropPosition({ liningDimensionsHeight: item });
				});
				this.additional.obkatkaDimensionsWidth.forEach((item) => {
					if (item.value === this.obkatkaDimensionsWidth)
						this.setPropPosition({ obkatkaDimensionsWidth: item });
				});
				this.additional.obkatkaDimensionsHeight.forEach((item) => {
					if (item.value === this.obkatkaDimensionsHeight)
						this.setPropPosition({ obkatkaDimensionsHeight: item });
				});
			} else {
				this.setPropPosition({
					overlay: null,
					overlayColor: null,
					liningDimensionsWidth: null,
					liningDimensionsHeight: null,
					obkatkaDimensionsWidth: null,
					obkatkaDimensionsHeight: null,
				});
			}
		},
		selectedOverlay(index) {
			this.setPropPosition({ overlay: this.additional.overlay[index] });
		},
		selectedOverlayColor(index) {
			this.setPropPosition({
				overlayColor: this.additional.overlayColors[index],
			});
		},
		liningDimensionsWidth(val) {
			if (this.visabilityInner) {
				this.additional.liningDimensionsWidth.forEach((item) => {
					if (item.value === val)
						this.setPropPosition({ liningDimensionsWidth: item });
				});
			}
		},
		liningDimensionsHeight(val) {
			if (this.visabilityInner) {
				this.additional.liningDimensionsHeight.forEach((item) => {
					if (item.value === val)
						this.setPropPosition({ liningDimensionsHeight: item });
				});
			}
		},
		obkatkaDimensionsWidth(val) {
			if (this.visabilityInner) {
				this.additional.obkatkaDimensionsWidth.forEach((item) => {
					if (item.value === val)
						this.setPropPosition({ obkatkaDimensionsWidth: item });
				});
			}
		},
		obkatkaDimensionsHeight(val) {
			if (this.visabilityInner) {
				this.additional.obkatkaDimensionsHeight.forEach((item) => {
					if (item.value === val)
						this.setPropPosition({ obkatkaDimensionsHeight: item });
				});
			}
		},
	},
	props: [],
	template: `
	<AdditionalRow>
		<AdditionalButton title="Выбрать накладку на входную дверь" v-show="!visabilityInner"
			:class="{hidden: visabilityInner}" v-on:setInnerVisibility="visabilityInner = !visabilityInner" />
		<AdditionalInner v-show="visabilityInner" v-if="isAdditionalReady()">
			<AdditionalButtonHide title="накладку" v-on:setInnerVisibility="deactivate"  />
			<ConfigBlockWrap class="mt-48">
				<ConfigBlockWrapTitle>Модель накладки</ConfigBlockWrapTitle>
				<Swiper :basicSlidesPerView="1.3" :basicSpaceBetween="20" :breakpointsForSlides="3">
					<div class="swiper-slide" v-for="(slide, index) of additional.overlay">
						<SimpleItem :image="slide.image" :price="slide.price" :priceType="2" :key="index"
							:class="{active: selectedOverlay === index}" v-on:setActive="setActiveElement(index)" />
					</div>
				</Swiper>
			</ConfigBlockWrap>

			<div class="config-block__wrap mt-48">
				<ConfigBlockWrapTitle>Цвет покрытия</ConfigBlockWrapTitle>
				<ConfigBlockColors>
					<Color v-for="(color, index) of additional.overlayColors" :color="color" :key="index" v-on:setActiveColor="selectedOverlayColor = index"
						:class="{active: selectedOverlayColor===index}" />
				</ConfigBlockColors>
			</div>

			<ConfigBlockInner class="mt-48">
				<div class="config-block_linnig">
				<div class="config-block-wrap">
						<ConfigBlockWrapTitle :tippyContent="additional.liningDimensionsDescription">Размеры накладки
						</ConfigBlockWrapTitle>
						<Select class="mt-20" label="Ширина, мм" :options="additional.liningDimensionsWidth" :selected="additional.liningDimensionsWidth[0]" v-on:selectSelectedValue="liningDimensionsWidth = $event.value" />
						<Select class="mt-20" label="Высота, мм" :options="additional.liningDimensionsHeight" :selected="additional.liningDimensionsHeight[0]" v-on:selectSelectedValue="liningDimensionsHeight = $event.value" />
					</div>
					<div class="config-block-wrap">
						<ConfigBlockWrapTitle :tippyContent="additional.obkatkaDimensionsDescription">Обкатка
						</ConfigBlockWrapTitle>
						<Select class="mt-20" label="Ширина, мм" :options="additional.obkatkaDimensionsWidth" :selected="additional.obkatkaDimensionsWidth[0]" v-on:selectSelectedValue="obkatkaDimensionsWidth = $event.value" />
						<Select class="mt-20" label="Высота, мм" :options="additional.obkatkaDimensionsHeight" :selected="additional.obkatkaDimensionsHeight[0]" v-on:selectSelectedValue="obkatkaDimensionsHeight = $event.value" />
					</div>
				</div>
			</ConfigBlockInner>

		</AdditionalInner>
	</AdditionalRow>
`,
});
